import { useMutation, useQueryClient } from "@tanstack/react-query";
import { actualizeazaTargetareTinta } from "@/api/endpoints/targetareTinte";
import { queryKeys } from "@/lib/queryClient";

export function useActualizeazaTargetareTinta() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: actualizeazaTargetareTinta,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.tinte() });
      queryClient.invalidateQueries({
        queryKey: queryKeys.targetare.activitate(),
      });
    },
  });
}
